import React, {useState} from 'react'
import { randomUuid, encodeBlurry } from '../../../classes/lib-common'
import ComponentpediaLink, {ComponentpediaLinkTypes} from '../componentpedia';
import RegistryUrl from '../registry.url';

const Library = ({ result, language, blurred, isLatest, findDependencyInTree, isAccountDefault, isFont }) => {
    // console.log(result)
    const Icon = () => (
        blurred || (result.exclusions && result.exclusions.length) ?
            <i className="fa fa-check-circle fa-lg" style={{ color: "lightgray" }}></i>
            :
            (!result.warnings.length && !result.violations.length) ?
                <i className="fa fa-check-circle fa-lg" style={{ color: "green" }}></i>
                :
                <React.Fragment>
                    {
                        result.warnings.length ?
                            <i className={"fa fa-question-circle " + iconDimension} style={{ color: "orange" }}></i>
                            : null
                    }
                    {
                        result.violations.length ?
                            <i className={"fa fa-exclamation-circle " + iconDimension} style={{ color: "red" }}></i>
                            : null
                    }
                </React.Fragment>

    )

    const Library = () => {
        return <div className="ml-3 d-inline-flex" id={libraryKeyName}>
            {!blurred && isLatest ?
                <div className="text-link pr-0 mr-1" style={{ whiteSpace: "pre-wrap" }} value="" title={`${libraryDisplayName} Click to see in dependency tree`} 
                    tabIndex={0}
                    onClick={() => { findDependencyInTree(language, result.library.name + " " + result.version, {blurred}) }}
                    onKeyUp={(e) => { findDependencyInTree(language, result.library.name + " " + result.version, {key: e.key, blurred}) }}
                >{libraryDisplayName}</div> :
                <div className="pr-0 mr-1" value="">{libraryDisplayName}</div>
                
            }

            {result.library.unityPlugin ? <small className="badge badge-light badge-xs badge-light-extra">unity plugin</small> : ""}

            {blurred? null : <ComponentpediaLink language={language} name={result.library.name} version={result.version} type={ComponentpediaLinkTypes.SM} extraInfo={{unityPlugin: result.library.unityPlugin}} /> }
            {blurred || isFont? null : <RegistryUrl name={result.library.name} version={result.version} language={language} extraInfo={{unityPlugin: result.library.unityPlugin}} /> } 

        </div>
    }

    const Description = () => {

        if (blurred) return ""


        return result.exclusions && result.exclusions.length ?
            <React.Fragment>
                <div className="vspacer10"></div>
                {result.exclusions[0].description}
                <div className="vspacer10"></div>
            </React.Fragment>
            :
            <React.Fragment>
                {
                    result.warnings.map(warning => {
                        if (isAccountDefault) return null
                        if (foundWarnings.includes(warning)) return null;
                        foundWarnings.push(warning)
                        return (
                            <p key={"licensing-warn-" + warning} className="h5 mt-3 mb-3"><strong>
                                <span className="hspacer50">&nbsp;</span>
                                {warning}
                            </strong></p>
                        )
                    })
                }{
                    result.violations.map((violation, i) => {
                        if (isAccountDefault) return null
                        if (foundViolation.includes(violation.policyName)) return null;
                        foundViolation.push(violation.policyName)
                        return (
                            <p key={violation.policyName + i} className="h5 mt-3 mb-3"><strong>
                                <span className="hspacer50">&nbsp;</span>
                                License denied due to the policy "{violation.policyName}".
                            </strong></p>
                        )
                    })
                }
            </React.Fragment>

    }

    const iconDimension = isAccountDefault ? "fa-lg" : "fa-3x";

    const foundWarnings = [];
    const foundViolation = [];

    let libraryDisplayName = `${result.library.displayName} ${result.version||""}`
    let libraryKeyName = `${result.library.name}${result.version||""}`
    if(blurred){
        libraryDisplayName = `${encodeBlurry(result.library.displayName)} ${encodeBlurry(result.version)}`
        libraryKeyName =  `${encodeBlurry(result.library.name)}${encodeBlurry(result.version)}`
    }

    return (
        <div className="license-library" id={"licensing-" + libraryKeyName}>
            <Icon />
            <Library />
            <Description />

        </div>
    )
}

const Flags = ({ result , blurred}) => {
    return (
        <div className="license-flags">
            {result.scope ? <small className="badge badge-inverted-primary">{!blurred ? result.scope : encodeBlurry("random.scope")}</small> : ""}
            {!blurred &&result.transitive ? <small className="badge badge-light badge-light-extra">transitive</small> : ""}
        </div>
    )
}

const Licenses = ({ result, blurred, isUserAdmin, removeData, librariesData, setCopyrightLicense}) => {
    const id = randomUuid()
    if (result.exclusions && result.exclusions.length) removeData[result.exclusions[0].id] = { uuid: result.exclusions[0].id, library: result.library.name };
    else {
        librariesData[id] = {
            title: ` library: ${result.library.displayName} - (version: ${result.version})`,
            domain: "licensing",
            content: {
                library: {
                    language: result.library.language,
                    name: result.library.name
                },
                version: result.version,
                kind: "library",
            }
        }
    }

    return (
        <div className="license-name">
            {
                result.licenses.map((license, j) => {
                    const licenseDisplayName = license.wildcard ? license.name : license.id
                    if(blurred) return <span href="" key={"name-fragment-key" + encodeBlurry(license.id) + j} className="mr-3 text-link" rel="noopener noreferrer">{encodeBlurry(licenseDisplayName)}</span>
                    return (
                        <>
                            {(result.library.unityPlugin && isUserAdmin)? <span class='btn btn-link' onClick={()=>setCopyrightLicense(librariesData[id])}>{licenseDisplayName}</span> : null}
                            {(result.library.unityPlugin && isUserAdmin) ? null : <a href={license.uri} key={"name-fragment-key" + license.id + j} target="_blank" className="mr-3" rel="noopener noreferrer">
                                    <span title={licenseDisplayName.toLowerCase()==="copyright"?license.name:licenseDisplayName}>{licenseDisplayName}</span>
                                </a> } 
                        </>
                    )
                })
            }
        </div>
    )
}


const openLocationsModal = () => {
    window.$("#license-display-modal").modal("show")
}

const Actions = ({ result, displayActions, removeMitigation, isUserAdmin, setLicenseToFix, setLocationsInfo, newMitigations, removeData, librariesData, setCopyrightLicense}) => {

    if (!displayActions) return ""

    const id = randomUuid();
    if (result.exclusions && result.exclusions.length) removeData[result.exclusions[0].id] = { uuid: result.exclusions[0].id, library: result.library.name };
    else {
        librariesData[id] = {
            title: ` library: ${result.library.displayName} - (version: ${result.version})`,
            domain: "licensing",
            content: {
                library: {
                    language: result.library.language,
                    name: result.library.name
                },
                version: result.version,
                kind: "library",
            }
        }
    }
    return (
        <div className="license-action hidden-xs">
            <div className="dropdown hide-on-edit">
                <button className="btn btn-default " type="button" id="library-actions" data-toggle="dropdown" aria-haspopup="true">
                    <span className="fas fa-ellipsis-v"></span>
                </button>
                <ul className="dropdown-menu dropdown-menu-right actions-dropdown-menu">
                    {result.exclusions && result.exclusions.length ?
                        <li className="action dropdown-item" id="remove-action" onClick={() => !result.exclusions[0].readonly ? removeMitigation(removeData[result.exclusions[0].id]) : ""}><a
                            className="license-issue-demitigate"
                            title={result.exclusions[0].readonly ?
                                "This exclusion is embedded in the codebase on the '.meterian' file, and therefore it cannot be removed from this UI."
                                : "Remove this exclusion"
                            }>Remove</a></li>
                        : <React.Fragment>
                            {result.warnings.length ?
                                <li className="action dropdown-item" id="exclude-action" onClick={() => newMitigations("mitigated", librariesData[id])}><a
                                    className="license-issue-exclude"
                                    title="Exclude this license">Exclude</a></li>
                                : ""
                            }
                            {result.violations.length ?
                                <React.Fragment key={"fragment-key-viol-" + result.library.name}>
                                    <li className="action dropdown-item" id="report-action"  onClick={() => newMitigations("invalid", librariesData[id])}><a
                                        className="license-issue-exclude"
                                        title="Report this license as invalid">Report</a></li>
                                    <li className="action dropdown-item" id="exclude-action" onClick={() => newMitigations("mitigated", librariesData[id])}><a
                                        className="license-issue-exclude"
                                        title="Exclude this license">Exclude</a></li>
                                </React.Fragment>
                                : ""
                            }
                            {!result.violations.length && !result.warnings.length ?
                                <li className="action dropdown-item" id="report-action" onClick={() => newMitigations("invalid", librariesData[id])}><a
                                    className="license-issue-exclude"
                                    title="Report this license as invalid">Report</a></li>
                                : ""
                            }
                            {   
                                result.locations?.length?
                                <li className="action dropdown-item" id="see-locations-action" onClick={() => {
                                    setLocationsInfo(result)
                                    setTimeout(()=>{
                                        openLocationsModal()
                                    }, 250)
                                }}><a
                                        className="license-locations-see"
                                        title="See the locations where this component was found" >See locations</a></li>
                                : ""
                            }
                            {isUserAdmin ?
                                <React.Fragment>
                                    <div className="dropdown-divider"></div>
                                    <li className="action dropdown-item" id="license-fix-action" onClick={() => setLicenseToFix(librariesData[id])}><a
                                        className="license-issue-fix"
                                        title="Edit the license of this component" >Edit license</a></li>
                                    <li className="action dropdown-item" id="copyright-action" onClick={() => setCopyrightLicense(librariesData[id])}><a
                                        className="license-issue-copyright"
                                        title="Edit copyright license of this component">Edit copyright</a></li>
                                </React.Fragment>
                                : ""
                            }
                            
                        </React.Fragment>
                    }
                </ul>
            </div>
        </div>
    )
}


const StandardView = (props) => {
    const standardLicenses = props.licensing.section.standard
    let licenses = []

    const mapEntries = (report, currentlyDisplayedCount) => {


        const components = []
        if (!props.sortByRisk) report.results.sort((a, b) => a.library.name.toLowerCase() > b.library.name.toLowerCase() ? 1 : -1)
        // for (let index = 0; index < report.results.length; index++) {
        const count = report.results.length > currentlyDisplayedCount ? currentlyDisplayedCount : report.results.length
        for (let index = 0; index < count; index++) {
            const result = report.results[index]
            if(result.library && result.library.name && result.library.name.includes("DLL:")) result.library.isDLL = true
            const blurred = result.canBeBlurred && !props.isAccountDefault && props.teaser;
            const css = `license-wrapper${blurred ? " blurry" : ""}`;
            components.push(
                <div className={css} key={report.language + index}>
                    <Library isFont={report.language==="fonts"} result={result} language={report.language} blurred={blurred} isLatest={props.isLatest} findDependencyInTree={props.findDependencyInTree} isAccountDefault={props.isAccountDefault} removeData={props.removeData} librariesData={props.librariesData} />
                    <Flags result={result} blurred={blurred}/>
                    <Licenses result={result} blurred={blurred} isUserAdmin={props.isUserAdmin} setCopyrightLicense={props.setCopyrightLicense} removeData={props.removeData} librariesData={props.librariesData} />
                    <Actions result={result} displayActions={props.displayActions} removeMitigation={props.removeMitigation} isUserAdmin={props.isUserAdmin} setCopyrightLicense={props.setCopyrightLicense} setLicenseToFix={props.setLicenseToFix} setLocationsInfo={props.setLocationsInfo} newMitigations={props.newMitigations} removeData={props.removeData} librariesData={props.librariesData} />
                </div>
            )
        }
        return components

    }
    const displayedLicensesConstant = 500
    const [currentlyDisplayedCount, setCurrentlyDisplayed] = useState(displayedLicensesConstant)

    for (let repIndex = 0; repIndex < standardLicenses.length; repIndex++) {
        const report = standardLicenses[repIndex]
        // if (props.toggledLanguages.includes(report.language)) licenses.push("");
        licenses.push(report.results.length > 0 ?
            <div data-language={report.language} key={report.language} className="mb-5">
                <div className="license-wrapper version-title">
                    <div className="license-library"><b>Library ({report.language})</b></div>
                    <div className="license-flags"></div>
                    <div className="license-name"><b>Licenses</b></div>
                    {props.displayActions ? <div className="license-action hidden-xs"><b>Actions</b></div> : ""}
                </div>
                {
                    mapEntries(report, currentlyDisplayedCount)
                }
                {
                    currentlyDisplayedCount < report.results.length ? 
                        <div className="license-wrapper">
                            <div className="btn btn-primary ml-auto mr-1" onClick={async(e)=>{
                                const label = e.currentTarget.querySelector(".button-label")
                                const spinner = e.currentTarget.querySelector(".spin")
                                label.style.display="none"
                                spinner.style.display="block"
                                await new Promise(resolve=>setTimeout(resolve,500))
                                licenses = []
                                label.style.display="block"
                                spinner.style.display="none"
                                setCurrentlyDisplayed(currentlyDisplayedCount+displayedLicensesConstant)
                            }}>
                                <span className="button-label">See more {report.language} libraries</span>
                                <i className="fas fa-circle-notch spin spin-clear" style={{display: "none"}}></i>
                            </div>
                            <div className="btn btn-primary mr-auto  ml-1" onClick={async(e)=>{
                                const label = e.currentTarget.querySelector(".button-label")
                                const spinner = e.currentTarget.querySelector(".spin")
                                label.style.display="none"
                                spinner.style.display="block"
                                await new Promise(resolve=>setTimeout(resolve,500))
                                licenses = []
                                label.style.display="block"
                                spinner.style.display="none"
                                setCurrentlyDisplayed(report.results.length)
                            }}>
                                <span className="button-label">See all {report.language} libraries</span>
                                <i className="fas fa-circle-notch spin spin-clear" style={{display: "none"}}></i>
                            </div>
                            <span className="position-absolute"><i>Currently showing {currentlyDisplayedCount}/{report.results.length}</i></span><br/>
                        </div>:
                        null
                }
                <div className="license-wrapper"></div>
            </div> : null
        )
    }

    return licenses
}


export default StandardView